
export const setEmailErrMsg = (temp_state) => {
    temp_state.errMsg = "";
    if (
        temp_state.purpose.selectedItem === "" ||
        ((temp_state.purpose.selectedItem === "Any other purpose" ||
            temp_state.purpose.selectedItem === "Holiday/festival greeting") &&
            temp_state.purpose.otherPurpose === "")
    ) {
        temp_state.errMsg = "Please provide purpose";
    }

    temp_state["isGenEmailBtnDisabled"] = temp_state.errMsg !== "";
};

export const emailFormBody = ({ propState, userDetails }) => {
    const bodyobj = {
        order_id: propState["order_id"],
        prompt_type: "email",
        form_schema: {},
        name: userDetails?.name || "",
        email: userDetails?.email || "",
    };

    // Purpose
    if (propState["purpose"]["isSelectedOthers"]) {
        if (
            propState["purpose"]["selectedItem"] === "Holiday/festival greeting"
        ) {
            bodyobj.form_schema["purpose"] =
                propState["purpose"]["selectedItem"];
            bodyobj.form_schema["Holiday name"] =
                propState["purpose"]["otherPurpose"];
        } else {
            bodyobj.form_schema["purpose"] =
                propState["purpose"]["otherPurpose"];
        }
    } else {
        bodyobj.form_schema["purpose"] = propState["purpose"]["selectedItem"];
    }

    // Subject
    if (propState["subject"] !== "") {
        bodyobj.form_schema["subject"] = propState["subject"];
    }

    // Tone
    if (propState["tone"]["selectedItem"]) {
        bodyobj.form_schema["tone"] = propState["tone"]["selectedItem"];
    }

    // Main Points/Details
    bodyobj.form_schema["mainPoints"] = propState["mainPoints"];

    return bodyobj;
};

export const repopulate = (temp_state, data) => {

    temp_state.order_id=data.order_id
    let form_schema = data?.form_schema;
    if (form_schema?.purpose) {
        if (
            temp_state.purpose.dropDownList.includes(form_schema?.purpose) &&
            form_schema?.purpose !== "Others"
        ) {
            temp_state.purpose.title = form_schema?.purpose;
            temp_state.purpose.selectedItem = form_schema?.purpose;
        } else {
            temp_state.purpose.title = "Others";
            temp_state.purpose.selectedItem = "Others";
            temp_state.purpose.otherPurpose = form_schema?.purpose;
            temp_state.purpose.isSelectedOthers = true;
        }
    }
    if (form_schema?.tone) {
        temp_state.tone.title = form_schema?.tone;
        temp_state.tone.selectedItem = form_schema?.tone;
    }
    if (form_schema?.subject) {
        temp_state.subject = form_schema?.subject;
    }
    if (form_schema?.mainPoints) {
        temp_state.mainPoints = form_schema?.mainPoints;
    }
    temp_state.pageType="Generated Section"
    temp_state.repopulate=true;
    temp_state.emailGenerated = emailFormat(data?.descriptions);
};

// Helper function for formatting response

export const emailFormat =(responseArr) =>{
    return responseArr.map((resObj, i) => {
        // reducer description schema
        return {
            status: "Just now",
            description_generated: resObj?.description_generated || "",
            editedDesc: resObj?.description_generated || "",
            isEditing: false,
            isEdited: resObj?.is_edited || false,
            like_status: resObj?.like_status,
            generated_at: resObj?.updatedAt || "",
            gen_id: resObj.gen_id,
            rewrite_count:resObj?.rewrite_count || 0
        };
    });
}

// Helper fuction to check action response

export const checkActRes =(res, action)=> {
    let descObj = res?.data[action.payload.descInd];
    if (res?.status !== "success") {
        return false;
    }
    if (res?.data.length === 0) {
        return false;
    }
    if (descObj["gen_id"] !== action.payload.gen_id) {
        return false;
    }
    Object.keys(action.payload.actionInfo).forEach((actKey) => {
        if (descObj[actKey] !== action.payload.actionInfo[actKey]) {
            return false;
        }
    });

    return true;
}

